import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../../utils/httpCommon";
import { useApiUrls } from "../../useApiUrl";
import { toast } from "../../../utils/snackbarHelper";
import { toastMessage } from "../../../constants/strings";
import { useIsFeatureFlagEnabled } from "../../../featureFlags/useIsFeatureFlagEnabled";
import { apiUrls } from "../../../utils/apiUrls";

export type MergeIntoType = "route" | "trap";

type MergeRoutesTrapsRequest = {
  trapIdsToMerge: number[];
  routeIdsToMerge: number[];
  mergeIntoSelect: MergeIntoType;
  mergeInto: number;
  trailerEquipmentId: number | null;
  tractorEquipmentId: number | null;
  straightTruckEquipmentId: number | null;
  doorId: number | null;
  startTime: string;
  date: number;
  sicId: number;
  customName?: string;
  presetRouteId: number;
  driverId: number | null;
};

export const useMergeRoutesTraps = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const hookUrls = useApiUrls();
  const isEndpointHookEnabled = useIsFeatureFlagEnabled(
    "inbound-3763-endpoint-hook-client"
  );
  const { mergeRoutesAndTraps } = isEndpointHookEnabled ? hookUrls : apiUrls;

  return useMutation({
    mutationFn: async (request: MergeRoutesTrapsRequest) => {
      const { status } = await http.post(mergeRoutesAndTraps, request);
      return status;
    },
    onSettled: () => {
      queryClient.invalidateQueries(); // The invalidate logic would be highly complex and error prone, so just invalidate all queries
    },
    onSuccess: () => onSuccess?.(),
    onError: () => toast(toastMessage.generics.error, { variant: "error" }),
  });
};
